<template>
  <div class="edit-content">
    <AnchorContainer class="commodity-container">
      <AnchorItem
        id="baseInfo"
        :name="baseInfoNameObj.name"
        :icon="baseInfoNameObj.icon"
        :icon-color="baseInfoNameObj.iconColor"
      >
        <SalaryBaseInfo
          ref="salaryBaseInfo"
          v-model="baseInfo"
          :is-copy="isCopy"
          :is-set="isSet"
        ></SalaryBaseInfo>
      </AnchorItem>
      <AnchorItem id="gradSet" name="梯度设置">
        <SalaryGradSet
          ref="salaryGradSet"
          v-model="salarySetInfo"
          :is-set="isSet"
        ></SalaryGradSet>
      </AnchorItem>
      <AnchorItem v-if="planId && !isCopy" id="schoolSet" name="适用学校">
        <SalaryRelSchool :plan-id="planId" :is-set="isSet"></SalaryRelSchool>
      </AnchorItem>
      <div v-if="!isSet" class="formbtnbox-430-bottom">
        <Button @click="handleGoBack">取消</Button>
        <Button type="primary" @click="handleSave">保存</Button>
      </div>
    </AnchorContainer>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import orderCenterApi from '@/request/orderCenter/index.js';
// 锚点组件start
import AnchorContainer from '@c/Anchor/AnchorContainer.vue';
import AnchorItem from '@c/Anchor/AnchorItem.vue';
// 锚点组件end
import SalaryBaseInfo from './components/SalaryBaseInfo.vue';
import SalaryGradSet from './components/SalaryGradSet.vue';
import SalaryRelSchool from './components/SalaryRelSchool.vue';
export default {
  components: {
    AnchorContainer,
    AnchorItem,
    SalaryBaseInfo,
    SalaryGradSet,
    SalaryRelSchool
  },
  provide() {
    // findRuleRequire (子组件有用到这个方法，不要删！)
    return { SalarySettingEditInstance: this };
  },
  data() {
    return {
      baseInfoNameObj: {},
      gradSetNameObj: {},
      baseInfo: {
        planName: '', // 教师课酬方案名称
        termSelect: '',
        yearCode: '',
        termCode: '',
        yearTerm: '',
        isCalLeave: false
      },
      salarySetInfo: {},
      planId: '',
      isCopy: false, // 复制功能
      isSet: false // 配置适用学校功能
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['theUserIdentity'])
  },
  created() {
    this.planId = this.$route.query.planId ? this.$route.query.planId : '';
    this.isCopy = !!this.$route.query.isCopy;
    this.isSet = !!this.$route.query.isSet;
    this.planId ? this.getDetailByPlanId() : '';
  },
  methods: {
    ...mapMutations(['DELETE_CACHEROUTE', 'CLOSE_BROWSINGHISTORYLIST']),
    fillKeyValue(target, value) {
      Object.keys(target).forEach(item => {
        if (value[item]) {
          target[item] = value[item];
        }
      });
      return target;
    },
    async getDetailByPlanId() {
      const params = {
        planId: this.planId
      };
      const res = await orderCenterApi.getDetailByPlanIdApi(params);
      if (res.status === 200 && res.message) {
        res.message.isCalLeave = res.message.isCalLeave === 1;
        this.baseInfo = this.fillKeyValue(this.baseInfo, res.message);
        this.isCopy ? '' : this.baseInfo.termSelect = 'true';
        let selectCourseType = '';
        res.message.coursefeeAllotPlanItemInfoDtoList.forEach((item, index) => {
          const list = item.allotPlanItemInfoDtoList.map(x => {
            const { onceFee, ...other } = x;
            const onceFeeTrue = onceFee / 100;
            return {
              onceFee: onceFeeTrue,
              ...other,
              errFee: '',
              errMax: ''
            };
          });
          this.salarySetInfo[item.courseType] = {
            calType: item.calType + '',
            list
          };
          if (index === 0) {
            selectCourseType = item.courseType;
          }
        });
        this.$nextTick(() => {
          this.isCopy ? '' : this.$refs.salaryBaseInfo.fillTerm();
          this.$refs.salaryBaseInfo.checkForm();
          this.$refs.salaryGradSet.fillSetting(selectCourseType);
        });
      }
    },
    // 取消返回上一页
    handleGoBack() {
      this.$router.push({
        name: 'basicInfoCenter_opeManage_teacherSalarySettingList'
      });
    },
    handleSave() {
      this.$Spin.show();
      this.$refs.salaryBaseInfo.checkForm();
      this.$refs.salaryGradSet.getFormValidate();
      const tag = this.checkAllRule();
      if (tag) {
        this.submitForm();
      } else {
        this.$Spin.hide();
      }
    },
    async submitForm() {
      const params = this.dealFormData();
      // params.forEach()
      if (this.planId && !this.isCopy) {
        this.editPlan(params);
      } else {
        this.addPlan(params);
      }
    },
    async addPlan(params) {
      let res = {};
      try {
        res = await orderCenterApi.addCoursefeeAllotPlanApi(params);
      } finally {
        this.$Spin.hide();
      }
      if (res.status === 200) {
        this.$Message.success('添加成功！');
        this.DELETE_CACHEROUTE('teacherSalarySettingList')
        this.$router.push({
          name: 'basicInfoCenter_opeManage_teacherSalarySettingList'
        });
        this.CLOSE_BROWSINGHISTORYLIST(this.$route.name)
      }
    },
    async editPlan(params) {
      const paramsTrue = { ...params, planId: this.planId };
      let res = {};
      try {
        res = await orderCenterApi.editCoursefeeAllotPlanApi(paramsTrue);
      } finally {
        this.$Spin.hide();
      }
      if (res.status === 200) {
        this.$Message.success('更新成功！');
        this.$router.push({
          name: 'basicInfoCenter_opeManage_teacherSalarySettingList'
        });
        this.CLOSE_BROWSINGHISTORYLIST(this.$route.name)
      }
    },
    dealFormData() {
      const { termSelect, yearTerm, isCalLeave, ...otherBase } = this.baseInfo;
      otherBase.isCalLeave = isCalLeave ? 1 : 0;
      const list = [];
      Object.keys(this.salarySetInfo).forEach(x => {
        const obj = {};
        obj.courseType = x;
        obj.addCoursefeeAllotPlanItemBOList = this.salarySetInfo[x].list.map(j => {
          const { errFee, errMax, ...otherInfo } = j;
          otherInfo.onceFee = otherInfo.onceFee * 100;
          return otherInfo;
        });
        obj.calType = this.salarySetInfo[x].calType;
        list.push(obj);
      });
      return {
        ...otherBase,
        item: list
      };
    },
    // 校验必填项
    checkAllRule() {
      if (
        this.baseInfoNameObj.formTag && this.gradSetNameObj.formTag
      ) {
        return true;
      } else {
        return false;
      }
    },
    findRuleRequire(context, tag, name) {
      // 拿到必填的项
      const requireKeys = Object.keys(context[`${tag}Required`]).filter(
        item => {
          return (
            context[`${tag}Required`][item] &&
            context[`${tag}Required`][item].require
          );
        }
      );
      // 拿到必填项已填了多少个
      let fillLength = 0;
      requireKeys.forEach(item => {
        if (context[`${tag}Required`][item]) {
          context[`${tag}Required`][item].status ? (fillLength += 1) : '';
        }
      });
      const hasFinished = requireKeys.length === fillLength;
      // 表单所有要填写的项目是否都已填写正确
      const formTag = Object.keys(context[`${tag}Required`]).every(item => {
        return context[`${tag}Required`][item].status;
      });
      this[`${tag}NameObj`] = {
        name: `${name} （${fillLength} / ${requireKeys.length}）`,
        icon:
          !formTag && this.haveCheckForm
            ? 'ios-alert'
            : hasFinished
              ? 'md-checkmark-circle'
              : '',
        iconColor:
          !formTag && this.haveCheckForm
            ? '#ed4014'
            : hasFinished
              ? '#19be6b'
              : '',
        formTag
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.edit-content {
  height: calc(100vh - 140px);
}
.commodity-container {
  padding-bottom: 80px;
}
.formbtnbox-430-bottom {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000;
  left: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 0 -4px 2px rgba(0, 0, 0, 0.03);
  padding: 16px 0;

  button + button {
    margin-left: 16px;
  }
}
</style>
